module.exports = __webpack_public_path__ + "img/45ab049212fab22cb82d9774791b72a5.853ddd15.jpg";